// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"378":"7ca85cfa","559":"742012f8","646":"d20981fd","745":"e0cd99b6"}[chunkId] + ".chunk.js";
};